// McPostman is being decommissioned; subscription forms are intercepted
// client-side and relayed to the Marketing Cloud form handler instead.
export const MCPOSTMAN_FORM_ACTION =
  'https://mcpostman.publicradio.org/subscription_requests';

export const MCPOSTMAN_PLUS_FORM_ACTION =
  'https://mcpostman.publicradio.org/subscription_requests_plus';

export const SFMC_FORM_ACTION =
  'https://mcq2g9ckqzdrdgt-pjltbhvq75r4.pub.sfmc-content.com/ivldamibqd4';

export const SUBSCRIPTION_FORM_PROXY = '/api/forms/subscription';

export const VOTER_GUIDE_SFMC_FORM_PROXY = '/api/forms/voter-guide-signup';

/**
 * Voter Guide signup — Marketing Cloud coordinates.
 *
 * The relay writes the reader into `VOTER_GUIDE_SIGNUP_DE`, then fires
 * `VOTER_GUIDE_EVENT_KEY` to start the `2026_Voter_Guide_Confirmation`
 * journey, whose email (`MPRNews_BuildYourBallot`) reads `ballot` and `lock`
 * straight back out of that data extension with AMPscript `Lookup()` to build
 * the reader's personal ballot link. Write the row before firing the event or
 * the lookup finds nothing and the email falls back to a generic URL.
 *
 * **The MID matters.** Journey Builder objects live in the Minnesota Public
 * Radio business unit; the `SFMC_ACCOUNTID` in the environment is the APMG
 * parent, where subscribers and publication lists live. A token for the parent
 * cannot see this journey at all — it 404s — so these calls pass
 * `VOTER_GUIDE_SFMC_MID` explicitly. Don't "simplify" it away, and don't
 * repoint `SFMC_ACCOUNTID` at it: subscriber and list calls belong on the
 * parent.
 */
export const VOTER_GUIDE_SFMC_MID =
  process.env.SFMC_VOTER_GUIDE_MID || '10965225';

export const VOTER_GUIDE_EVENT_KEY =
  process.env.SFMC_VOTER_GUIDE_EVENT_KEY ||
  'APIEvent-5471048c-54e8-2799-b71b-ab08b95960a1';

/** Shared ("ent.") data extension, addressed by its plain key over REST. */
export const VOTER_GUIDE_SIGNUP_DE = 'Emails_From_Branch';
